import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePinInput_InputAdapter_instancee9jybw7zm7d5 as SavePinInput_InputAdapter_instance } from '../type/adapter/SavePinInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePinMutation_VariablesAdapterClass;
function SavePinMutation_VariablesAdapter() {
  if (SavePinMutation_VariablesAdapterClass === VOID) {
    class $ {
      o6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.o4a('input');
        obj(SavePinInput_InputAdapter_instance).u3x(writer, customScalarAdapters, value.n6h_1);
      }
    }
    initMetadataForObject($, 'SavePinMutation_VariablesAdapter');
    SavePinMutation_VariablesAdapterClass = $;
  }
  return SavePinMutation_VariablesAdapterClass;
}
var SavePinMutation_VariablesAdapter_instance;
function SavePinMutation_VariablesAdapter_getInstance() {
  return SavePinMutation_VariablesAdapter_instance;
}
//region block: init
SavePinMutation_VariablesAdapter_instance = new (SavePinMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePinMutation_VariablesAdapter_instance as SavePinMutation_VariablesAdapter_instance3iph10kl6nehk,
};
//endregion

//# sourceMappingURL=SavePinMutation_VariablesAdapter.mjs.map
